import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { selectDataType } from '../../services/types';
import { ChevronDown } from 'lucide-react';

export function Select(
   { title, data = [], isSmall, handleSelectItem, emptyMsg }: 
   { title?: string, data: selectDataType[], isSmall?: boolean, handleSelectItem: (id: any) => void, emptyMsg?: string }
) {
   const [menuToggle, setMenuToggle] = React.useState<boolean>(false);
   const selectRef = React.useRef<HTMLDivElement>(null);

   // ---
   React.useEffect(() => {
   const handleClickOutside = (e: MouseEvent) => {
      if (selectRef.current && !selectRef.current.contains(e.target as Node)) {
         setMenuToggle(false);
      }
   };
   window.addEventListener('click', handleClickOutside);
   return () => { window.removeEventListener('click', handleClickOutside) };
}, []);

   // ---
   const itemActive = data.find(item => item.isActive);

   return (
      <Main className="select" style={{ fontSize: isSmall ? '15px' : '18px' }}>
         { title ? <h4>{ title }</h4> : null }
         <div ref={ selectRef } onClick={ () => setMenuToggle(menu => !menu) }>
            { data.length ? ( itemActive ? <span>{ itemActive?.name }</span> : <span style={{ opacity: 0.65 }}>{ emptyMsg }</span>) : <span style={{ opacity: 0.65 }}>{ (emptyMsg || '') }</span> }
            <ChevronDown style={{ opacity: data.length ? 0.5 : 0.2 }} />
            { menuToggle && data.length ? <ul className="nowheel">{
               data.filter(item => !item.isHide).map(item => (
                  <li key={ item.id } onClick={ _=> handleSelectItem(item.id as number) }>
                     <span>{ item.name }</span>
                     <span>{ item.id === itemActive?.id ? <FontAwesomeIcon icon={ faCheck } /> : null }</span>
                  </li>
               ))
            }</ul> : null}
         </div>
      </Main>
   );
}

// ---
const Main = styled.div`
   display: flex;
   align-items: center;
   
   h4 {
      font-weight: 400;
      margin-right: 15px;
   }
   > div {
      position: relative;
      display: flex;
      align-items: center;
      // background-color: #F6F6F6;
      border: 1px solid rgb(200, 200, 200);
      border-radius: 10px;
      padding: 5px 10px;
      height: 40px;
      width: 100%;
      cursor: pointer;
      /* white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis; */

      > span {
         width: 100%;
         color: #696F74;
         margin-right: 15px;
         white-space: nowrap;
         overflow: hidden;
         text-overflow: ellipsis;
      }
   }
   ul {
      position: absolute;
      top: calc(100% + 7.5px);
      right: 0;
      width: 100%;
      z-index: 4000;
      background-color: rgb(245, 245, 245);
      box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
      max-height: 194.4px;
      overflow: auto;
      border-radius: 10px;

      li {
         display: flex;
         align-items: center;
         justify-content: space-between;
         padding: 0 10px;
         min-height: 32.4px;
         transition: all .2s ease-in-out;
         width: 100%;
         height: 40px;

         &:not(:last-of-type) {
            border-bottom: 1px solid rgb(215, 215, 215);
         }
         span {
            &:first-of-type {
               opacity: 0.8;
               width: 100%;
               overflow-wrap: break-word;
               overflow: hidden;
            }
            &:last-of-type {
               opacity: 0.5;
               margin-left: 7.5px;
            }
         }
         &:hover {
            background-color: #1E272E;
            color: #fff;

            span {
               opacity: 1;
            }
         }
      }
   }
`;